export const fontSize = 13;
export const lineHeight = 16;
export const maxTextContentWidth = 600;
export const fontWeight = 500;
export const inputWidth = 196;
export const strokeWidth = 2;
